export default {"src":"/fi/sahkoa/_next/static/media/unplugged.2969507b.svg","height":352,"width":576,"blurWidth":0,"blurHeight":0};